import { render, staticRenderFns } from "./registerRecord.vue?vue&type=template&id=95ebe4d6&scoped=true"
import script from "./registerRecord.vue?vue&type=script&lang=js"
export * from "./registerRecord.vue?vue&type=script&lang=js"
import style0 from "./registerRecord.vue?vue&type=style&index=0&id=95ebe4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ebe4d6",
  null
  
)

export default component.exports